// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"-name__-loca-__21TuB","Open":"-name__-loca-__1pVYR","Close":"-name__-loca-__3Yv1l","Logo":"-name__-loca-__3TkPv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 164
// module chunks = 0